import { Component, h, Prop, Method, Event, EventEmitter, Element } from '@stencil/core';

@Component({
  tag: 'dc-ui-header-flyout-nav-link',
  styleUrl: 'dc-ui-header-flyout-nav-link.scss',
  shadow: true,
})
export class DcUiHeaderFlyoutNavLink {
  @Element() el!: HTMLElement;
  @Prop() label: string;
  @Prop() href: string;
  @Prop() disabled?: boolean;
  @Prop() target?: '_blank' | '_self' | '_parent' | '_top';
  @Prop() rel?: string;

  @Event({ bubbles: true, composed: true }) dcSubitemSelect!: EventEmitter<{
    origin: 'click' | 'keydown';
    label: string;
    href: string;
    selected: boolean;
    event: Event;
    level: number | string;
  }>;

  private linkElement: HTMLAnchorElement;
  private isKeyboardEvent: boolean = false;

  @Method()
  async focusElement() {
    this.linkElement.focus();
  }

  private handleClick = (event: MouseEvent) => {
    // Skip if this was triggered by a keyboard event
    if (this.isKeyboardEvent) {
      this.isKeyboardEvent = false;
      return;
    }

    this.dcSubitemSelect.emit({
      origin: 'click',
      label: this.linkElement.querySelector('span')?.textContent || this.label,
      href: this.href,
      selected: false,
      event,
      level: this.getCurrentLevel(),
    });
  };

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      this.isKeyboardEvent = true;
      this.dcSubitemSelect.emit({
        origin: 'keydown',
        label: this.linkElement.querySelector('span')?.textContent || this.label,
        href: this.href,
        selected: false,
        event,
        level: this.getCurrentLevel(),
      });
    }
  };

  private getCurrentLevel = (): number | string => {
    // get the level of the current item if possible
    const menuContainer = this.el.closest('.menu-container');
    let level: number | string = 'unknown';
    if (menuContainer) {
      level = menuContainer.getAttribute('data-nav-level');
    }
    return level;
  };

  componentWillLoad() {
    if (!this.href) {
      this.disabled = true;
    }
  }

  render() {
    return (
      <a
        ref={(el) => (this.linkElement = el)}
        href={this.href}
        target={this.target}
        rel={this.rel}
        class={this.disabled ? 'disabled' : ''}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}>
        <span>{this.label || <slot />}</span>
      </a>
    );
  }
}
